// import { createApp } from 'vue'
// import App from './App.vue'
// import router from './router'
// import store from './store'
// // import { create, NConfigProvider } from 'naive-ui';

// import ToastPlugin from 'vue-toast-notification'
// import 'vue-toast-notification/dist/theme-bootstrap.css';

// import AOS from 'aos'
// import 'aos/dist/aos.css'

// // const naive = create({
// //     components: [NConfigProvider], // Include NConfigProvider component
// // });

// createApp(App)
// .use(store)
// .use(router)
// .use(AOS)
// .use(ToastPlugin)
// .mount('#app')


import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ToastPlugin from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-bootstrap.css';
import AOS from 'aos'
import 'aos/dist/aos.css'

const app = createApp(App)
app.use(store)
app.use(router)
app.use(AOS)
app.use(ToastPlugin)

app.mount('#app')

app.mixin({
  created() {
    const theme = localStorage.getItem('theme');
    if (theme) {
      this.$store.state.isDarkMode = theme === 'dark';
    }
  },
});